import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../layouts/UserLayout'
import { Box, Card, CircularProgress, Typography } from '@mui/material'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { transformDetailWithPhone } from '../utils/transformDetail'
import { useNavigate, useParams } from 'react-router-dom'
import { DOMAIN } from '../utils/api'
import { handleError } from '../utils/error'
import axios from 'axios'
import { getFromStorage } from '../utils/storage'
import { currentUserActions } from '../redux/store'
import { useDispatch } from 'react-redux'
import { mainGreen } from '../utils/color'

export default function SearchTimerDetail() {
	const dispatch = useDispatch()
	const { orderId } = useParams()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [searchDetail, setSearchDetail] = useState()
	const [loadingDetail, setLoadingDetail] = useState(true)

	const getSearchDetail = useCallback(
		async function () {
			setLoadingDetail(true)
			const url = `${DOMAIN}/user/search/timer-detail/${orderId}`
			try {
				const response = await axios({
					url,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setSearchDetail(response.data)
				setLoadingDetail(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, navigate, orderId, dispatch],
	)

	useEffect(() => {
		getSearchDetail()
	}, [getSearchDetail])

	return (
		<UserLayout>
			{loadingDetail ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Box sx={{ maxWidth: 992, margin: '0 auto' }}>
					<Card
						sx={{
							padding: '20px 20px 10px 20px',
							background: '#fff',
						}}>
						<Typography
							display='inline-flex'
							justifyContent='flex-start'
							alignItems='center'
							sx={{
								color: '#fff',
								background: mainGreen,
								mb: 1,
								padding: '2px 10px',
								borderRadius: '10px',
							}}>
							<ScheduleIcon sx={{ fontSize: '20px', marginRight: '5px' }} />
							{searchDetail?.timer.hours}:{searchDetail?.timer.minutes} - Ngày {searchDetail?.timer.date}/
							{searchDetail?.timer.month}/{searchDetail?.timer.year?.toString().slice(-2)}
						</Typography>
						<Typography>
							<b>Người tạo: </b>
							{searchDetail?.createOrderData.creator.name}
						</Typography>
						<Typography>
							<b>Khối lượng: </b>
							{searchDetail?.createOrderData.quantity?.toLocaleString()}kg
						</Typography>
						<Typography>
							<b>Tiền: </b>
							{searchDetail?.createOrderData.totalPrice?.toLocaleString()}đ
						</Typography>
						<Typography>
							<b>Thông tin: </b>
							<span
								dangerouslySetInnerHTML={{
									__html: transformDetailWithPhone(searchDetail?.createOrderData.detail),
								}}></span>
						</Typography>
					</Card>
				</Box>
			)}
		</UserLayout>
	)
}
